import React, { useCallback, useState, useEffect } from "react";
import { Accept, useDropzone } from "react-dropzone";

interface Props {
  acceptType: Accept | undefined;
  setFile: any;
  defaultRes?: any;
  defaultFile?: any;
}

const Dropzone: React.FC<Props> = (props) => {
  const { acceptType, setFile, defaultRes, defaultFile } = props;

  const [fileType, setFileType] = useState<number>(defaultRes?.type || 0);

  const useDisplayImage = () => {
    const [result, setResult] = useState(defaultFile);

    const uploader = (e: any) => {
      const imageFile = e;

      const reader = new FileReader();
      reader.addEventListener("load", (e: any) => {
        setResult(e.target.result);
      });

      reader.readAsDataURL(imageFile);
    };

    return { result, uploader };
  };
  const onDrop = useCallback((acceptedFiles: any) => {
    acceptedFiles.forEach((file: any) => {
      uploader(file);
    });
  }, []); //eslint-disable-line

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
    accept: acceptType,
  });

  const { result, uploader } = useDisplayImage();

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      let type = 0;
      if (acceptedFiles[0].type.indexOf("image") !== -1) {
        type = 0;
      } else if (acceptedFiles[0].type.indexOf("video") !== -1) {
        type = 1;
      } else if (acceptedFiles[0].type.indexOf("audio") !== -1) {
        type = 2;
      }

      setFileType(type);
    } else {
      setFileType(0);
    }
  }, [acceptedFiles]); //eslint-disable-line

  useEffect(() => {
    setFileType(defaultRes?.type || 0);
  }, [defaultRes]);

  useEffect(() => {
    setFile(result);
  }, [result]); //eslint-disable-line

  return (
    <button
      {...getRootProps()}
      type="button"
      className="min-h-[40px] w-[200px] m-auto relative border-solid border-[1px] border-[#bdbdbd] rounded-[4px] transition ease-in-out delay-150 bg-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-indigo-500 duration-300"
    >
      {!acceptedFiles && (
        <div className="absolute h-full w-full z-50 font-opensans font-xl text-[#A9A9A9] p-[8px]">
          UPLOAD LOGO/IMAGE
        </div>
      )}
      <input
        {...getInputProps()}
        placeholder="UPLOAD LOGO/IMAGE"
        className="relative z-1"
      />
      {fileType === 0 ? (
        result ? (
          <img
            src={result || defaultRes?.link}
            alt="UPLOAD LOGO"
            className="object-cover w-full relative z-1 max-w-none"
          />
        ) : (
          <button type="button">Upload Image</button>
        )
      ) : (
        <video
          src={result || defaultRes?.link}
          width="100%"
          controls
          className="relative z-1"
        />
      )}
    </button>
  );
};

export default Dropzone;
